import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import 'ag-grid-enterprise';
import {LoadingService} from '../../services/loading/loading.service';
import {FrtRatesBidcycles} from 'src/app/shared/common-components/common-structure';
import {AlertService} from '../../services/alert/alert.service';
import {CarrierRateProcurementService} from '../../services/carrier-rate-procurement/carrier-rate-procurement.service';
import {RatesSroMasterService} from '../../services/rates-sro-master/rates-sro-master.service';
import {UserService} from '../../services/user/user.service';
import {FrtRatesBidcyclesService} from 'src/app/services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import * as FileSaver from 'file-saver';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
    selector: 'app-carrier-rate-procurement',
    templateUrl: './carrier-rate-procurement.component.html',
    styleUrls: ['./carrier-rate-procurement.component.css'],
    standalone: false
})
export class CarrierRateProcurementComponent implements OnInit {
  public carrierTypeProcListDetails = [];
  public scacItems = [];
  public sroItems = [];
  public rateTypeItems = [];
  rateCycleItems: FrtRatesBidcycles[];
  public errorMessage = '';
  carrierRateProcurementGridOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  carrerColumnDefs: any;
  selectedBusinessType: any;
  noResults: any = null;
  currentUser: any;
  // toggle for the buttons
  disableGenerate = false;
  disableExport = true;

  searchTypes: string[] = [
    'FRT',
    'HHG'
  ];
  onGridRead;


  private tmssloader;
  carrierRateProcSearchGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder,
              public loader: LoadingService,
              private alertService: AlertService,
              private carrierRateProcService: CarrierRateProcurementService,
              private frtRateBidcyclesService: FrtRatesBidcyclesService,
              private userService: UserService,
              private ratesSroMasterService: RatesSroMasterService) {
    this.loader = loader;
    this.carrierRateProcSearchGroup = this.fb.group({
      typeSelect: new UntypedFormControl(null, Validators.required),
      scacSelect: new UntypedFormControl({value: ''}, Validators.required),
      sroSelect: new UntypedFormControl({value: ''}, Validators.required),
      rateCycleSelect: new UntypedFormControl(null, [Validators.pattern('^[0-9]*$'), Validators.required]),
      rateTypeSelect: new UntypedFormControl('', {validators: [Validators.required]})
    });

  }

  ngOnInit() {
    this.tmssloader = this.loader;
    // disable select boxes until user selects a type
    this.carrierRateProcSearchGroup.controls['scacSelect'].disable();
    this.carrierRateProcSearchGroup.controls['sroSelect'].disable();
    this.carrierRateProcSearchGroup.controls['rateCycleSelect'].disable();
    this.carrierRateProcSearchGroup.controls['rateTypeSelect'].disable();
    this.checkUserRole();

  }

  checkUserRole() {
    this.currentUser = 'HHG';
    this.currentUser = this.userService.getUserDetails().subscribe((user: any) => {
      this.currentUser = user.permissions;
      switch (this.currentUser) {
        case 'FRT & HHG':
          break;
        case 'HHG':
          this.searchTypes.splice(this.searchTypes.indexOf('FRT'), 1);
          break;
        case 'FRT':
          this.searchTypes.splice(this.searchTypes.indexOf('HHG'), 1);
          break;
        default:
          break;
      }
    });
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      domLayout: 'autoHeight',
      rowData: this.carrierTypeProcListDetails,
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  sortRateType(tempRateType: any) {
    const firstElement = tempRateType[0];
    const sortedRateType = tempRateType.slice(1).sort((a: any, b: any) => {
      return a.value - b.value;
    });
    return [firstElement, ...sortedRateType];
  }

  onSelectType(selectType: string) {
    if (selectType === 'FRT' || selectType === 'HHG') {
      this.selectedBusinessType = selectType;
      this.scacItems = [];
      this.sroItems = [];
      this.rateTypeItems = [];
      this.rateCycleItems = [];
      this.errorMessage = '';


      this.loader.show();
      // call to server for data.  Results will be stored in separate lists.
      this.carrierRateProcService.getSelectOptions(selectType)
        .subscribe((selectData: any) => {
            // load select boxes with query results
            this.scacItems = selectData.carrierList;
            this.sroItems = selectData.sroList;
            this.rateTypeItems = this.sortRateType(selectData.rateTypeList);
            this.tmssloader.show();
            this.frtRateBidcyclesService.getRatesBidCyclesByBusinessTypes(selectType).subscribe(allRateCycles => {
              this.rateCycleItems = allRateCycles;
              this.tmssloader.hide();
            }, error => {
              this.tmssloader.hide();
              this.alertService.error('There was an error retrieving Business Type');
            });

            this.loader.hide();
            // enable select boxes and generate button
            this.carrierRateProcSearchGroup.controls['scacSelect'].enable();
            this.carrierRateProcSearchGroup.controls['sroSelect'].enable();
            this.carrierRateProcSearchGroup.controls['rateCycleSelect'].enable();
            this.carrierRateProcSearchGroup.controls['rateTypeSelect'].enable();
            // set default values for DDLBs
            this.carrierRateProcSearchGroup.controls['scacSelect'].setValue('All');
            this.carrierRateProcSearchGroup.controls['sroSelect'].setValue('All');
            this.carrierRateProcSearchGroup.controls['rateCycleSelect'].setValue(null);
            this.carrierRateProcSearchGroup.controls['rateTypeSelect'].setValue('All');
            // set everything to untouch
            this.carrierRateProcSearchGroup.markAllAsTouched();
          }, (error: any) => {
            this.errorMessage = error;
            this.alertService.error('No records found for the search criteria ');
            this.loader.hide();
          }, () => {
            this.loader.hide();
          }
        );

    }
  }

  generateReport(formSelect) {
    this.loader.show();
    this.carrierRateProcService.getReport(formSelect).subscribe(report => {
      if (report && report.length == 0) {
        this.noResults = 'No rows to display, please adjust your filters';
      } else {
        this.noResults = null;
        this.carrerColumnDefs = this.carrierRateProcurementColumnDefs();
        this.carrierTypeProcListDetails = report;
        if (AppConstants.isNotNullCondition(this.carrierTypeProcListDetails)) {
          this.carrierTypeProcListDetails.sort((a, b) => a.scacSelect < b.scacSelect ? -1 : 1);
        }
        this.carrierRateProcurementGridOptions = this.initializeGridOptions();
        this.disableExport = false;
        this.loader.hide();
      }
    }, (error) => {
      this.alertService.error(error);
      console.log('Error.......... ', error);
      this.loader.hide();
    }, () => {
      this.loader.hide();
    });

  }

  carrierRateProcurementColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'SCAC',
          field: 'scacSelect',
          filter: 'agTextColumnFilter'
        },

      {
        headerName: 'SRO',
        field: 'sroSelect',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Rate Cycle',
        field: 'rateCycleSelect',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Rate Type',
        field: 'rateTypeSelect',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Count',
        field: 'rateTypeCount',
        filter: 'agNumberColumnFilter'
      }
    ];
  }

  rateTypeChange(value: any) {
    this.ratesSroMasterService.getSROsBybusinessTypeAndRateTypeId(this.selectedBusinessType, ((value === 'All') ? -1 : value)).subscribe(
      (data) => {
        this.sroItems = (data.length > 1) ? (data) : [];
      }, (error) => {
        console.log('having issue', error);
      }
    );
  }

  generateDownload(formSelect) {
    let reportResult: DownloadFileResponse;
    this.loader.show();
    this.carrierRateProcService.getCarrierRateProcXlsx(formSelect).subscribe(result => {
        reportResult = result as DownloadFileResponse;
        // convert to bytes then to blob to save as xlsx file
        const byteData: number[] = reportResult.byteData;
        const fileName: string = reportResult.fileName;
        const numRows: number = reportResult.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });

        if (numRows > 0) {
          // SAVE EXCEL FILE
          FileSaver.saveAs(blob, fileName);
          this.alertService.success('FAIC List Report created - ' + numRows + ' Records found');
        } else {
          this.alertService.success('No records found for selected options');
        }
        this.loader.hide();
      }, (error) => {
        this.alertService.error(error);
        console.log('Error.......... ', error);
        this.loader.hide();
      }, () => {

      }
    );

  }

  onSelectRateCycle() {
    if (this.carrierRateProcSearchGroup.get('rateCycleSelect').dirty) {
      this.disableGenerate = true;
    }
  }

  isGenerateDisabled() {
    return this.disableGenerate && (this.sroItems.length > 0);
  }

  isExportDisabled() {
    return this.disableExport;
  }

}
